@import '../../../globals/main.scss';

pn-bonus-progressbar-level {
  position: absolute;
  width: 0.1rem;
  left: 50%;
  &::after {
    content: '';
    width: 0.1rem;
    position: absolute;
    left: 0;
    border-left: 1px dashed #9b1c2e;
    top: 50%;
    transform: translateY(-50%);
    height: 3rem;
  }
  &:not([current]):nth-child(odd) {
    &::after {
      height: 7rem;
      margin-top: 0.6rem;
    }
  }
}

.progressbar-level-percentage {
  font-size: 0.75em;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -3.2rem;
  [current] > & {
    display: none;
  }
  pn-bonus-progressbar-level:not([current]):nth-child(odd) & {
    top: -4.8rem;
  }
}

.progressbar-level-value {
  font-size: 0.75em;
  white-space: nowrap;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 2.3rem;
  [current] > & {
    top: -3.2rem;
  }
  pn-bonus-progressbar-level:not([current]):nth-child(odd) & {
    top: 4.2rem;
  }
}
